enum Routes {
  TEACHER_RECOMMENDATIONS = '/teachers',
  TRIAL_OFFER_RECOMMENDATIONS = '/trial-offers',
}

export default Routes
